<script>
export default {
  name: 'SignInfoTransferRecord',
  props: {
    artistId: {
      type: String,
      required: true
    },
    detailMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingStatus: false,
      dataList: [],
      orderSort: { time_day: 'desc', id: 'desc' },//默认排序规则
      total: 0,
      pagData: { page_size: 15, current_page: 1 },
    }
  },
  methods: {
    handleQuery() {
      this.pagData.current_page = 1
      this.getList()
    },
    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getList()
    },

    async getList() {
      this.loadingStatus = true
      this.dataList = []
      if (this.artistId) {
        const pagingInfo = this.pagData
        const searchCondition = { artist_id: this.artistId }
        // Object.assign(searchCondition, pagingInfo)
        Object.assign(searchCondition, pagingInfo, { order: this.orderSort })
        const { list, pages } = await this.$api.signArtistGroupList(searchCondition)
        this.dataList = list || []
        this.pagData.page_size = pages.page_size
        this.pagData.current_page = pages.current_page
        this.total = pages.total
      }

      this.loadingStatus = false
    }
  },
  created() {
    this.handleQuery()
  }
}

</script>

<template>
  <div>
    <div class='theme-border flex-sb p-10 mb8' v-if='!detailMode'>
      <div></div>
      <div>
        <el-link @click='getList' style='font-size: 20px;font-weight: bolder'>转组记录</el-link>
      </div>
      <div><span style='display: none'>{{artistId}}</span></div>
    </div>
    <div>
      <el-table :data='dataList' stripe highlight-current-row border>
        <el-table-column type='index' label='序号' width='80' align='center'></el-table-column>
        <el-table-column prop='nickname' label='红人昵称' min-width='120' align='center'></el-table-column>
        <el-table-column prop='group_name' label='转入组' min-width='140' align='center'></el-table-column>
        <el-table-column prop='time_day' label='日期' min-width='110' align='center'></el-table-column>
        <el-table-column prop='remark' label='备注' min-width='200' align='center'></el-table-column>
        <el-table-column prop='created_at' label='操作时间' min-width='140' align='center'></el-table-column>
      </el-table>
      <div :class="detailMode ? 'detail-pagination-row' : 'flex-sb'">
        <el-button type='text' icon='el-icon-refresh' @click='handleQuery'>刷新</el-button>
        <m-pagination @pagination='getList' :total.sync='total' :limit.sync='pagData.page_size'
                      :page.sync='pagData.current_page'></m-pagination>
      </div>
    </div>

  </div>
</template>

<style scoped>
.detail-pagination-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>
